module.exports = __webpack_public_path__ + "static/media/jump.671e93fa.svg";